import {Component, OnInit, Output, EventEmitter, ChangeDetectorRef, TemplateRef, ViewChild} from '@angular/core';
import { MatDialog } from '@angular/material/dialog'; 
import { GlobalServiceService } from 'src/app/services/global/global-service.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit {
  @Output()
  onToggle = new EventEmitter();
  query = {}
  querySupplier = new EventEmitter();
  searching = false;
  classSidebar = new EventEmitter();


  classSidebarValue = "";
  classSidebarAlertValue = false;

  @ViewChild('VerazInform', { static: true }) verazModal: TemplateRef<any>;

  entity: any = {}

  types = [
    { id : 'id1', typeName: $localize`Tipo 1`},
    { id : 'id2', typeName: $localize`Tipo 2`},
    { id : 'id3', typeName: $localize`Tipo Gratis`}
  ];

  sexo = [
    { id : 'id1', typeName: $localize`Masculino`},
    { id : 'id2', typeName: $localize`Femenino`},
    { id : 'id3', typeName: $localize`Empresa`}
  ];
  urlAssets: string = localStorage.getItem('urlAssets');

  constructor(
    private changeDetection: ChangeDetectorRef,
    private dialog: MatDialog,
    public globalServiceService: GlobalServiceService
  ) { }

  toggleSearching(newVal = !this.searching) {
    this.searching = newVal;
    this.changeDetection.detectChanges();
  }
  ngOnInit() {
    // This method is not implemented
  }
  toggle() {
    this.onToggle.emit();
  }
  mergeQuery(obj: any) {
    Object.assign(this.query, obj);
    this.querySupplier.emit(this.query);
  }

  showSidebar(){
    if(this.classSidebarValue === ""){
      this.classSidebarValue = "active";
    }else{
      this.classSidebarValue = "";
    }
    this.classSidebar.emit(this.classSidebarValue);
  }

  showSidebarAlert(classSidebarAlertValue =  !this.classSidebarAlertValue){
    this.classSidebarAlertValue = classSidebarAlertValue;
  }

  openModalVeraz(){
    this.openDialogWithRef(this.verazModal);
  }

  openDialogWithRef(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef);
  }
  closeModalVeraz(){
    this.dialog.closeAll();
  }

}
